import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const FilterListIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="filter-lines" {...props} />;
};

export { FilterListIcon };
